module.exports = __webpack_public_path__ + "img/print.03edb9b3.svg";